import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { fetchNotificationDetails, fetchNotificationUsers, resetNoticationDetails } from '../Redux/Actions/Details'
import PieChart from 'michelangelo/dist/WebComponents/Charts/PieChart'
import { Link } from 'react-router-dom'
import BackArrow from '../Shared/Icons/icon-backarrow-grey.svg'
import InfoIcon from '../Shared/Icons/icon-info-grey.svg'
import SubHeader from '../Shared/Display/SubHeader'
import styled from 'styled-components'
import NotificationUsersTable from '../Shared/Data/NotificationUsersTable'
import { localeDateTimeString } from '../Shared/timeutils'
import { useLocation } from 'react-router'
import { getDateFilter, getGroupFilter, processDate, processGroup } from '../utils/analytics-utils'
import { componentCreated } from '../Redux/Actions/DateFilter'

/** @const {number} pageTotals */
const pageTotals = 5

const GraphDiv = styled.div`
  ${(props) => {
    if (!props.isSmallScreen) {
      return `
          width: 50%;
          height: 100%;
      `
    } else {
      return `
          width: 100%;
          margin-bottom: 10px;
      `
    }
  }}
  float: left;
  //height: 100%;
`
const StyledDiv100 = styled.div`
  width: 100%;
  float: left;
  height: auto;
`
const LegendTable = styled.table`
  width: 280px;
  margin-bottom: 20px;
`
const LeftSpan = styled.span`
  float: left;
  margin: 0 12px;
`
const RightSpan = styled.span`
  float: right;
`
const LastUpdated = styled.div`
  padding-bottom: 20px;
  font-weight: 700;
`
const GraphsContainer = styled.div`
  padding-bottom: 20px;
  height: 320px;
`
const GraphContainer = styled.div`
  padding: 10px 0;
  height: 100%;
  background: #FFFFFF;
`
const ItemDetailLink = styled.h6`
  font-weight: bold;
  color: #3FA8F0;
  font-size: 16px;
  font-weight: 700
`

const deliveryLabels = ['Delivered', 'Failed (Unsubscribed)', 'Failed (Errored)']
const deliveryBgColors = ['#0ABD63', '#ECB33D', '#F07B7B', '#3FA8F0']
const deliveryTooltips = ['Number of pushes successfully sent to Google and Apple servers. Does not indicate device receipt of notifications.',
  'Messages failed to be delivered to this number of devices because the device has uninstalled your app or unsubscribed from notifications.',
  'Number of notifications that did not get sent out due to a server error that occurred.',
  'The number of notifications that are queued to be sent.']
const platformBgColors = ['#75D5E2', '#3FA8F0']
const platformLabels = ['Apple iOS', 'Google Android']
const options = {
  maintainAspectRatio: false,
  responsive: false,
  // callback to build a html legend as needed
  legendCallback: function (chart) {
    const text = []
    text.push('<ul style="width: 280px; float: left;">')
    text.push('<table style="width: 280px;">')
    text.push('<tbody>')
    for (let i = 0; i < chart.data.datasets[0].data.length; i++) {
      text.push('<tr>')
      text.push('<td>')
      text.push('<li>')
      text.push('<span style="background-color:' + chart.data.datasets[0].backgroundColor[i] + '; margin: 12px; height: 12px; width: 12px; border-radius: 50%; display: inline-block;"></span>')
      text.push('</td>')

      if (chart.data.labels[i]) {
        text.push('<td style="padding-top: 7px;">')
        text.push('<span style="margin: 12px;">')
        text.push(chart.data.labels[i])
        text.push('</span>')
        if (chart.data.labels.length > 2) {
          text.push('<div class="tooltip">')
          text.push('<img src=' + InfoIcon + ' alt=' + InfoIcon + ' />')
          text.push('</span>')
          text.push('<span class="tooltipText">' + deliveryTooltips[i] + '</span>')
          text.push('</div>')
        }
        text.push('</td>')
      }
      text.push('<td>')
      text.push('<span style="margin-left: 30px; float: right;">' + chart.data.datasets[0].data[i] + '</span>')
      text.push('</td>')
      text.push('</li>')
      text.push('</td>')
      text.push('</tr>')
    }
    text.push('</tbody>')
    text.push('</table>')
    text.push('</ul>')
    return text.join('')
  }
}

function NotificationDetails () {
  const location = useLocation()
  const dispatch = useDispatch()

  const id = useSelector(state => state.account.ID)
  const userAnalyticsEnabled = useSelector(state => state.account.userAnalyticsEnabled)
  const redirect = useSelector(state => state.account.redirect)
  const data = useSelector(state => state.details.notification)
  const users = useSelector(state => state.details.notificationUsers)
  const dateFilterStore = useSelector(state => state.dateFilter)
  const name = 'NotificationDetails'

  const [isSmallScreen, setIsSmallScreen] = useState(!(window.innerWidth >= 1472))
  const [deliveryData, setDeliveryData] = useState([])
  const [platformData, setPlatformData] = useState([])
  const [dataReceived, setDataReceived] = useState(false)
  const [totalSent, setTotalSent] = useState(0)
  const [confirmed, setConfirmed] = useState(0)
  const [delivered, setDelivered] = useState(0)
  const [page, setPage] = useState(1)
  const [createdDate, setCreatedDate] = useState(null)

  const dateFilterFromStore = getDateFilter(dateFilterStore, name)
  const dateFilter = dateFilterFromStore ? dateFilterFromStore.dateFilter || 'Week' : 'Week'

  const groupFilter = getGroupFilter(dateFilterStore, name) || ''
  const dateInterval = dateFilter ? dateFilter.dateInterval || null : null

  useEffect(() => {
    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  useEffect(() => {
    dispatch(componentCreated(name))
  }, [])

  useEffect(() => {
    if (data.title !== 'Loading' && !dataReceived) {
      buildDeliveryPieData()
    }
  }, [data])

  useEffect(() => {
    update(processDate(dateFilter), processGroup(groupFilter))
  }, [page])

  useEffect(() => {
    newQuery(location.search.substring(1).split('&'))
  }, [])

  const newQuery = (query) => {
    const qobj = {}
    let newDateFilter
    query.forEach((q) => {
      qobj[q.split('=')[0]] = q.split('=')[1]
    })
    if (dateFilter === 'Custom' && dateInterval) {
      newDateFilter = dateInterval
    } else {
      newDateFilter = dateFilter
    }
    update(processDate(newDateFilter), processGroup(groupFilter), id)
  }

  const handleResize = () => {
    setIsSmallScreen(!(window.innerWidth >= 1472))
  }

  const update = (date, group, newID) => {
    const ID = newID || id
    const searchQ = location.search.substring(1).split('&')
    searchQ.forEach((q) => {
      searchQ[q.split('=')[0]] = q.split('=')[1]
    })
    dispatch(fetchNotificationDetails(ID, searchQ.type, searchQ.id))
    dispatch(fetchNotificationUsers(ID, searchQ.type, searchQ.id, {
      limit: pageTotals,
      offset: (page - 1) * pageTotals
    }))
  }

  useEffect(() => {
    return () => dispatch(resetNoticationDetails())
  }, [])

  const buildDeliveryPieData = () => {
    if (data.title === 'Loading') return
    const deliveryDataFromProps = data.deliveryData
    const platformDataFromProps = data.platformData
    const totalDelivered = deliveryDataFromProps.totalDelivered || 0
    const totalFailedUnsubsc = deliveryDataFromProps.totalFailed || 0
    const totalFailedErr = deliveryDataFromProps.totalErrored || 0

    const totalSent = deliveryDataFromProps.totalSent
    const confirmed = deliveryDataFromProps.confirmed
    const deliveryData = [totalDelivered, totalFailedUnsubsc, totalFailedErr]
    setDeliveryData(deliveryData)
    setTotalSent(totalSent)
    setConfirmed(confirmed)
    setDelivered(totalDelivered)
    setPlatformData([platformDataFromProps.ios, platformDataFromProps.android])
    setDataReceived(true)

    const createdDate = data.createdDate
    const formattedDate = localeDateTimeString(createdDate)
    setCreatedDate(formattedDate)
  }

  if (userAnalyticsEnabled) {
    const searchQ = location.search.substring(1).split('&')
    searchQ.forEach((q) => {
      searchQ[q.split('=')[0]] = q.split('=')[1]
    })

    return (
      <div id='NotificationDetailsPage'>
        <div className='toolbar'>
          <Link to={'/notifications'}>
            <img src={BackArrow} className='interactive' alt='back' />
          </Link>
          <div className='subTitle'>
            <h2>{data.title}</h2>
            <SubHeader type='NotificationDetails' value={data.notificationType === 'ALERT' ? 'Broadcast Alert Details' : 'Push Notification Details'} />
            {searchQ.type === 'CONTENT' &&
              <Link to={{ pathname: '/content', search: `?id=${searchQ.id}` }}>
                <ItemDetailLink>Go to Content Overview Page</ItemDetailLink>
              </Link>
            }
            {searchQ.type === 'ALERT' &&
              <Link to={{ pathname: '/alert', search: '?id=' + searchQ.id + '&date=Week&filter=__' }}>
                <ItemDetailLink>Go to Broadcast Alert Overview Page</ItemDetailLink>
              </Link>
            }
          </div>
        </div>
        <StyledDiv100>
          <LastUpdated>Last Updated {localeDateTimeString(data.lastOneSignalAPIUpdated) || createdDate}</LastUpdated>
          <GraphsContainer>
            <GraphDiv isSmallScreen={isSmallScreen}>
              <GraphContainer className={isSmallScreen ? '' : 'marginRight10'}>
                <div className='chartTitle'>
                  <h3>Delivery Statistics</h3>
                </div>
                <LegendTable>
                  <tbody>
                    <tr>
                      <td>
                        <StyledDiv100>
                          <LeftSpan>Total Registered Users</LeftSpan>
                          <div className='tooltip'><span><img src={InfoIcon} alt={InfoIcon} /></span>
                            <span className='tooltipText'>Total number of registered users that are subscribed and unsubscribed to the targeted group(s).</span>
                          </div>
                        </StyledDiv100>
                      </td>
                      <td><RightSpan>{totalSent}</RightSpan></td>
                    </tr>
                  </tbody>
                </LegendTable>
                {deliveryData.length > 0 && (
                  <PieChart chartId='chart1' data={deliveryData} labels={deliveryLabels} colors={deliveryBgColors} options={options} height={200} />
                )}
                <LegendTable>
                  <tbody>
                    <tr>
                      <td>
                        <StyledDiv100 className='marginTop30'>
                          <LeftSpan>Confirmed</LeftSpan>
                          <div className='tooltip'><span><img src={InfoIcon} alt={InfoIcon} /></span>
                            <span
                              className='tooltipText'>Number of devices that have confirmed delivery of notifications.</span>
                          </div>
                        </StyledDiv100>
                      </td>
                      <td><RightSpan className='marginTop30'>{confirmed}</RightSpan></td>
                    </tr>
                  </tbody>
                </LegendTable>
              </GraphContainer>
            </GraphDiv>
            <GraphDiv isSmallScreen={isSmallScreen}>
              <GraphContainer className={isSmallScreen ? '' : 'marginLeft10'}>
                <div className='chartTitle'>
                  <h3>Platform Statistics</h3>
                </div>
                <LegendTable>
                  <tbody>
                    <tr>
                      <td>
                        <StyledDiv100>
                          <LeftSpan>Total Delivered</LeftSpan>
                        </StyledDiv100>
                      </td>
                      <td><RightSpan>{delivered}</RightSpan></td>
                    </tr>
                  </tbody>
                </LegendTable>
                {platformData.length > 0 && (
                  <PieChart chartId='chart2' data={platformData} labels={platformLabels} colors={platformBgColors} options={options} height={200} />
                )}
              </GraphContainer>
            </GraphDiv>
          </GraphsContainer>
        </StyledDiv100>

        <StyledDiv100>
          <NotificationUsersTable
            title='Registered and Subscribed Users'
            data={users.users || []}
            fields={[{ ref: 'name', title: 'User Name' },
              { ref: 'regCode', title: 'Regcode' },
              { ref: 'email', title: 'Email' }]}
            changeOffset={(i) => {
              setPage(i)
            }}
            page={page}
            totalUsers={Math.ceil(users.count / pageTotals)}
            tooltipText={`This data is all the registered and subscribed users in the groups associated with the ${data.notificationType === 'ALERT' ? 'Broadcast Alert.' : 'Content Push Notification.'}`}
          />
        </StyledDiv100>

      </div>
    )
  } else {
    return (
      <div className='NotificationTable'>
        <div className='adminPage'>
          <p>Push notifications analytics have not been turned on. To do so, go to Master Administrator Account Settings
            and enable User Analytics</p>
        </div>
        <div className='adminPageContainer'><a className='buttonRedirect' href={redirect}>Go to Master Administrator
          Account Settings</a></div>
      </div>
    )
  }
}

export default NotificationDetails
